import { logout } from "store/auth";
import axiosInstance from './axios'
import { errorMessageToast } from "helpers/common"
// import { logout } from "store/slices/authSlice"

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
    async (arg, { dispatch }, extraOptions) => {
      try {
        const config = typeof arg === "string" ? { url: arg } : arg;
        let { url, method = 'GET', data = undefined, params = null, headers = {} } = config;

        const result = await axiosInstance({
          url: baseUrl + url,
          method,
          data,
          params,
          headers,
        })
        if(result?.success !== true) {
          throw new Error("Response was not ok")
        }

        return {
          data: result || null,
        }
      } catch (axiosError) {
        console.error("Error occurred in API request: ", axiosError);
        const err = axiosError;
        if(err?.status === 401) {
          // console.log(401)
          dispatch(logout());
          return;
        }
        if(!extraOptions?.suppressErrorToast) {
          const message = err.response?.data?.message || err.response?.data?.error;
          errorMessageToast(message || "Network Error!", {
            id: 'axiosError'
          });
        }
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        }
      }
    }

export default axiosBaseQuery;